import { __assign, __spreadArray, __read } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useRef } from 'react';
import { useListBox } from 'react-aria';
import { Text } from '../../Text/Text.js';
import { Box } from '../../Box/index.js';
import '../../hooks/useDetectInputMethod.js';
import '@reach/auto-id';
import { useTheme } from '../../hooks/useTheme.js';
import { Section } from './Section.js';
import { Option } from './Option.js';

function Dropdown(props) {
    var ref = useRef(null);
    var _a = props.listBoxRef, listBoxRef = _a === void 0 ? ref : _a, state = props.state;
    var listBoxProps = useListBox(props, state, listBoxRef).listBoxProps;
    var handleStyleProps = useTheme().handleStyleProps;
    var dropdownProps = handleStyleProps({ size: props.size }, { themeKey: "typeaheadDropdown" });
    return (jsx(Box, __assign({}, dropdownProps, { children: jsxs("ul", __assign({}, listBoxProps, { ref: listBoxRef }, { children: [state.collection.size > 0 &&
                    __spreadArray([], __read(state.collection), false).map(function (item) {
                        return item.type === "section" ? (jsx(Section, { section: item, state: state }, item.key)) : (jsx(Option, { item: item, state: state }, item.key));
                    }), state.collection.size === 0 && props.noMatchesFoundText && (jsx(Box, __assign({ themeKey: "typeaheadOption", sx: { cursor: "default", "--list-option-height": "auto" } }, { children: jsx(Text, { children: props.noMatchesFoundText }) })))] })) })));
}

export { Dropdown };
//# sourceMappingURL=Dropdown.js.map
